import type { ReactNode } from "react";
import { Card, SectionTitle } from "../styles";

export interface SectionCardProps {
  /** `data-testid` applied to the card element. */
  testId: string;
  /** Optional heading rendered above the card body. */
  title?: ReactNode;
  children: ReactNode;
}

/**
 * The shared card shell used by every Payment & Shipping section: a padded,
 * bordered {@link Card} with an optional {@link SectionTitle}. Kept presentation
 * only so sections can be composed and tested without duplicating the chrome.
 */
export function SectionCard({ testId, title, children }: SectionCardProps) {
  return (
    <Card data-testid={testId}>
      {title && <SectionTitle>{title}</SectionTitle>}
      {children}
    </Card>
  );
}
